import { FormLabel, Stack } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React, { forwardRef } from "react";
import { Controller, useFormContext } from "react-hook-form";

type Type_Props_DatePicker = {
    name: string;
    label?: string;
    rules?: Record<string, any>;
    format?: string;
};

const MuiDateTimePicker = forwardRef<HTMLInputElement, Type_Props_DatePicker>(
    ({ name, label, rules, format = "YYYY-MM-DD HH:mm", ...props }, ref) => {
        const { formState, control } = useFormContext();

        return (
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({ field }) => (
                    <Stack gap={0.5}>
                        {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
                        <DateTimePicker
                            {...field}
                            {...props}
                            value={field.value ? dayjs(field.value) : null}
                            format={format}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    error: !!formState.errors[name],
                                    helperText: formState?.errors[name]
                                        ?.message as string,
                                },
                            }}
                            inputRef={ref || field.ref}
                        />
                    </Stack>
                )}
            />
        );
    },
);

MuiDateTimePicker.displayName = "MuiDateTimePicker";

export default MuiDateTimePicker;
